import { render, staticRenderFns } from "./accountCreate.vue?vue&type=template&id=452341df&scoped=true&lang=html&"
import script from "./accountCreate.vue?vue&type=script&lang=js&"
export * from "./accountCreate.vue?vue&type=script&lang=js&"
import style0 from "./accountCreate.vue?vue&type=style&index=0&id=452341df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452341df",
  null
  
)

export default component.exports